// extracted by mini-css-extract-plugin
export default {"page":"Orders_page__6WzDF","title":"Orders_title__ylGVH","orders":"Orders_orders__q4eC5"};